import { render, staticRenderFns } from "./SLSectionContent.vue?vue&type=template&id=36b34594&scoped=true&"
import script from "./SLSectionContent.vue?vue&type=script&lang=js&"
export * from "./SLSectionContent.vue?vue&type=script&lang=js&"
import style0 from "./SLSectionContent.vue?vue&type=style&index=0&id=36b34594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b34594",
  null
  
)

export default component.exports